export default __webpack_public_path__ + "static/media/eye.f0317e47.svg";